
export const TARGET_SRC = '/targets/hop_thanh_truc.mind';
export const PRODUCTS = {
  'hop-2-banh': {
    anchorIndex: [0, 1, 2],
    targetSrc: '/targets/hop_thanh_truc.mind',
    anchors: {
      0: { videoSrc: '/videos/Hop_Thanh_Truc.mp4' },
      1: { videoSrc: '/videos/Hop_2_banh.mp4' },
      2: { videoSrc: '/videos/Hop_Thanh_Truc.mp4' }
    },
    info: {
      tag:   'Pakgo - Trung Thu 2026',
      title: 'Xu Hướng Bao Bì Mới Nhất',
      body:  ''
    }
  },
  'hop-hoi-ca': {
    anchorIndex: [0],
    targetSrc: '/targets/hop_hoi_ca.mind',
    anchors: {
      0: { videoSrc: '/videos/Hop_Thanh_Truc.mp4' }
    },
    info: {
      tag:   'Pakgo - Trung Thu 2026',
      title: 'Xu Hướng Bao Bì Mới Nhất',
      body:  ''
    }
  }
};
